/** An absolute sync-api URL for `path`, from VITE_SYNC_API_URL. */
export function syncApiUrl(path: string): string {
  const base = import.meta.env.VITE_SYNC_API_URL ?? "http://localhost:3001";
  return new URL(path, base).toString();
}
